import { render, staticRenderFns } from "./PreviewSalaryModal.vue?vue&type=template&id=38a12f9e&scoped=true"
import script from "./PreviewSalaryModal.vue?vue&type=script&lang=js"
export * from "./PreviewSalaryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a12f9e",
  null
  
)

export default component.exports